import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function Services() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/services").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/services", { name: name.trim() });
      toast.success("Serviço adicionado!");
      setName("");
      load();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const remove = async (id) => {
    await api.delete(`/services/${id}`);
    toast.success("Serviço removido.");
    load();
  };

  const customs = items.filter((s) => s.custom);
  const defaults = items.filter((s) => !s.custom);

  return (
    <div className="space-y-5 animate-in-up max-w-2xl" data-testid="services-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Banco de serviços</h1>
        <p className="text-sm text-slate-500">Serviços disponíveis na calculadora de orçamento</p>
      </div>

      <form onSubmit={add} className="flex gap-2">
        <Input className="h-12" placeholder="Ex: Instalação de piso-teto" data-testid="service-name"
               value={name} onChange={(e) => setName(e.target.value)} />
        <Button type="submit" className="h-12 bg-sky-600 hover:bg-sky-700 text-white" data-testid="service-add-btn">
          <Plus className="h-4 w-4 mr-1" /> Adicionar
        </Button>
      </form>

      {customs.length > 0 && (
        <div>
          <h2 className="text-sm font-semibold text-slate-700 mb-2">Seus serviços</h2>
          <div className="grid gap-2">
            {customs.map((s) => (
              <Card key={s.id} className="border-slate-200" data-testid={`service-custom-${s.id}`}>
                <CardContent className="p-3.5 flex items-center justify-between">
                  <span className="text-sm font-medium">{s.name}</span>
                  <Button variant="ghost" size="icon" className="h-10 w-10 text-red-500 hover:bg-red-50 hover:text-red-700"
                          onClick={() => remove(s.id)} data-testid={`service-delete-${s.id}`}>
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      )}

      <div>
        <h2 className="text-sm font-semibold text-slate-700 mb-2">Serviços padrão</h2>
        <div className="flex flex-wrap gap-2">
          {defaults.map((s) => (
            <Badge key={s.id} variant="outline" className="bg-white border-slate-200 text-slate-700 px-3 py-1.5 text-sm" data-testid={`service-default-${s.id}`}>
              {s.name}
            </Badge>
          ))}
        </div>
      </div>
    </div>
  );
}
